// extracted by mini-css-extract-plugin
export default {"container":"t0-z","heading":"u0-z","links":"v0-z","copy":"w0-z","subCopy":"x0-z","linksLeft":"y0-z","linksCenter":"z0-z","linksRight":"A0-z","link":"B0-z","onlyLink":"C0-z"};